export default __webpack_public_path__ + "static/media/chi8.28917161.jpg";